import React from 'react';
import style from './style.module.scss';

export const NewsNavigation = ({ link, meta }) => {
    
  return <div>news-navigation</div>;
};
